// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"index_pageWrap__7fqZf","flex":"index_flex__nwD9Z"};